export const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const HIDE_CHAT_PANEL = process.env.REACT_APP_HIDE_CHAT_PANEL === 'true';

export const FILE_BASE_URL = process.env.REACT_APP_BASE_FILE_URL;
